import './accordions'
import './forms'
import './header'
import './hero'
import './images'
import './slider'
import './counters'
import './videos'
import './popup'
import './tooltip'
import './gallery'



// WEBPACK FOOTER //
// ./public/assets/js/src/components/all.js